import Subjects from '@src/main/modules/messages/ui/subjects/Subjects';

const MessagesSubjectsPage = () => <Subjects />;

export default MessagesSubjectsPage;
